import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./AppContext";
import {esES, enEN, ILan} from './Languages'



export const LanContext = React.createContext<IMetaLan | null>(null);

interface IChild {
    children: JSX.Element
}

interface IMetaLan {
    Lan: ILanTwo,
    setLan: React.Dispatch<React.SetStateAction<ILanTwo>>
}

interface ILanTwo {
    Lan: string,
    dic: ILan
}

export const LanProvider = ({ children } : IChild) => {

    const App = useContext(AppContext)

    const [Lan, setLan] = useState<ILanTwo>({Lan:"esES", dic:esES})

    useEffect(() => {
        if (App!.app.myData.userLan === "enEN") {
            setLan((prev) => ({...prev, Lan:"enEN", dic:enEN}))
        } else {
            setLan((prev) => ({...prev, Lan:"esES", dic:esES}))
        }
    }, [App])

    return (
    <LanContext.Provider value={{Lan, setLan}}>
        {children}
    </LanContext.Provider>
  );
};